"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "getFieldIconUrl", {
    enumerable: true,
    get: function() {
        return getFieldIconUrl;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _constants = require("~/constants");
// Default icon for unknown/unsupported types
const DEFAULT_ICON = 'SingleLineText';
// Map relation types to their specific icons
const RELATION_ICON_MAP = {
    [_nocodbsdk.RelationTypes.MANY_TO_MANY]: 'mm-solid',
    [_nocodbsdk.RelationTypes.HAS_MANY]: 'hm-solid',
    [_nocodbsdk.RelationTypes.BELONGS_TO]: 'bt-solid',
    [_nocodbsdk.RelationTypes.ONE_TO_ONE]: 'oo-solid',
    [_nocodbsdk.RelationTypes.ONE_TO_MANY]: 'hm-solid',
    [_nocodbsdk.RelationTypes.MANY_TO_ONE]: 'bt-solid'
};
function getFieldIconUrl(uidt, relationType) {
    // Handle relationship icons
    if ((uidt === _nocodbsdk.UITypes.Links || uidt === _nocodbsdk.UITypes.LinkToAnotherRecord) && relationType) {
        const relationIcon = RELATION_ICON_MAP[relationType];
        if (relationIcon) {
            return `${_constants.NC_EMAIL_ASSETS_BASE_URL}/icons/${relationIcon}.png`;
        }
    }
    const iconName = uidt || DEFAULT_ICON;
    return `${_constants.NC_EMAIL_ASSETS_BASE_URL}/icons/${iconName}.png`;
}
